import { ButtonVariantEnum } from "../../components/Button/button.types";

export const tabsConstants = {
    userForm:"userForm",
    videos:"videos",
    media:"media",
    screenForm: "screenForm",
    users:"users",
    wallet:"waller",
    campaigns: "campaigns",
    screens: "screens" ,
    screenCampaignInsights:"screenCampaignInsights",
    controlHub:"control Hub",
}

export const headerButtonsArray = [
    { text: "Media", view: tabsConstants.videos, variant: ButtonVariantEnum.ternary },
    { text: "Media", view: tabsConstants.media, variant: ButtonVariantEnum.ternary },
    { text: "User Registration", view: tabsConstants.userForm, variant: ButtonVariantEnum.ternary },
    { text: "Screen Registration", view: tabsConstants.screenForm, variant: ButtonVariantEnum.ternary },
    { text: "Users", view: tabsConstants.users, variant: ButtonVariantEnum.ternary },
    { text: "Wallet", view: tabsConstants.wallet, variant: ButtonVariantEnum.ternary },
    { text: "Campaigns", view: tabsConstants.campaigns, variant: ButtonVariantEnum.ternary },
    { text: "Screens", view: tabsConstants.screens, variant: ButtonVariantEnum.ternary },
    { text: "Screen Campaign Insights", view: tabsConstants.screenCampaignInsights, variant: ButtonVariantEnum.ternary },
    { text: "Control Hub", view: tabsConstants.controlHub, variant: ButtonVariantEnum.ternary },
  ];

export const formTabs = {
    USER:0,
    SCREENS:0
}